import React, { useCallback, useMemo } from 'react';

interface Offer {
  id: string | number;
  name: string;
}

interface DraggableOfferProps {
  offer: Offer;
}

const DraggableOffer: React.FC<DraggableOfferProps> = ({ offer }) => {
  const onDragStart = useCallback(
    (event: React.DragEvent<HTMLDivElement>) => {
      console.log('dragstart', offer);
      // Payload consumed by DnDFlow.onDrop
      event.dataTransfer.setData('application/reactflow', JSON.stringify(offer));
      // IMPORTANT: also expose a *native* type. When the Criteria panel above the canvas
      // renders a react-querybuilder with drag & drop (User Attribute / URL Parameter rules),
      // react-dnd's HTML5Backend registers a window-level `dragstart` listener that calls
      // preventDefault() on any drag that is neither one of its own sources nor a native
      // type (text/plain, text/uri-list, text/html, Files). Without this line the browser
      // silently cancels the drag on those offer blocks (ZET regression after the .jsx -> .tsx switch).
      event.dataTransfer.setData('text/plain', String(offer.id));
      event.dataTransfer.effectAllowed = 'move';
    },
    [offer]
  );

  const draggableOffer = useMemo(
    () => (
      <div className='dndnode input' onDragStart={onDragStart} draggable>
        {offer.id} : {offer.name}
      </div>
    ),
    [offer, onDragStart]
  );

  return draggableOffer;
};

export default DraggableOffer;
